module.exports = __webpack_public_path__ + "static/media/unlink.c5a6cff4.svg";